import { css } from 'lit';

export const style = css`
  [hidden],
  .hidden {
    display: none;
  }

  @media (width >= 744px) {
    .checkout-phone-edit {
      display: flex;
    }

    fs-phone-number-field {
      margin-right: 1rem;
      width: 50%;
    }

    fs-select {
      width: 50%;
    }

    .disclosure {
      text-align: center;
    }
  }

  fs-phone-number-field,
  fs-select,
  fs-checkbox,
  fs-alert {
    margin-bottom: 1rem;
  }

  .disclosure {
    background-color: #f4f4f4;
    font-size: 14px;
    line-height: 21px;
    margin: 0 0 1rem;
    padding: 0.5rem;
  }

  .tcpaConsentText {
    margin-inline: 0.3rem;
  }
`;
